export const MOCK_USER = {
  access_token: 'YT2rb6juHmYZ1TfLcNMriwi1GQb9',
  token_type: 'bearer',
  expires_in: '899',
  refresh_token: 'kcm3aSQGhuQj5cJDURpJtenAmnvMvWsG',
  scope: 'productv1 productv1.all',
  userType: 'colleague',
  empId: '197698993',
  primaryEmailAddress: 'swapnilsit.kulkarni@test.morrisonsplc.co.uk',
  roleCode: '10020',
  forename: 'SIT Manager',
  surname: 'USER',
  retailRoleCode: '4',
}

export const MOCK_USER_EMPTY = {
  access_token: '',
  token_type: '',
  expires_in: '',
  refresh_token: '',
  scope: '',
  userType: '',
  empId: '',
  primaryEmailAddress: '',
  roleCode: '',
  forename: '',
  surname: '',
  retailRoleCode: '',
}
